import { useMemo } from 'react';

import SponsoredAdsProduct from 'components/search/SponsoredAdsProduct';
import { getLowStockLabelStatus } from 'helpers/cardUtils';
import useFetchProductRelation from 'hooks/useFetchProductRelation';
import { getProductWithRelatedStyles } from 'helpers/RecoUtils';

const SponsoredAdsWrapper = ({
  sponsoredAdsResults,
  msaImageParams,
  trackSponsoredAdImpressions,
  makeSponsoredAdClick,
  numSponsoredAds,
  sponsoredAdsToShow,
  CardBottomSlot = null
}) => {
  const products = useMemo(
    () =>
      sponsoredAdsResults?.map((product, i) => ({
        ...product,
        index: i,
        isSponsored: true
      })) || [],
    [sponsoredAdsResults]
  );

  const styleIds = products.map(product => product.styleId);
  const [productRelations] = useFetchProductRelation(styleIds);

  if (!sponsoredAdsToShow) {
    return null;
  }

  return sponsoredAdsResults.map((_props, i) => {
    const product = products[i];
    const { styleId, colorId } = product;
    product.isLowStock = getLowStockLabelStatus({ ...product });

    let productWithRelatedStyles = {};

    if (productRelations) {
      productWithRelatedStyles = getProductWithRelatedStyles(styleId, productRelations);
    }

    const { relatedStyles, ...productInfo } = productWithRelatedStyles;

    const finalProduct = { ...productInfo, ...product };

    return (
      styleId &&
      colorId && (
        <SponsoredAdsProduct
          key={`${styleId}-${colorId}`}
          product={finalProduct}
          relatedStyles={relatedStyles}
          numSponsoredAds={numSponsoredAds}
          trackSponsoredAdImpressions={trackSponsoredAdImpressions}
          makeSponsoredAdClick={makeSponsoredAdClick}
          msaImageParams={msaImageParams}
          CardBottomSlot={CardBottomSlot}
          includeSwatchRowSpace={true}
        />
      )
    );
  });
};

export default SponsoredAdsWrapper;
